import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const translations = {
  en: {
    volunteerHours: "Volunteer hours",
    myHours: "My volunteer hours",
    totalHours: "Total hours",
    hoursUnit: "hours",
    eventHours: "Volunteer hours for this event",
    eventHoursHint: "Hours are credited to participants only after verified check-in",
    hoursStatement: "Hours statement",
    annualCertificate: "Annual certificate",
    attendedLabel: "Attended",
    missedLabel: "Absent",
    manualAdjust: "Manual adjustment",
    adjustHours: "Adjust hours",
    adjustNote: "Reason / note",
    adjustAmountHint: "Positive number to add hours, negative to deduct",
    enableVolunteerHours: "Enable volunteer hours system",
    volunteerHoursSettingHint: "When enabled, admins can assign hours to events and volunteers accumulate them upon verified check-in",
    hoursAdminTitle: "Volunteer hours management",
    featureDisabled: "This feature is currently disabled by the platform manager",
    printStatement: "Print statement",
    shareCertificate: "Share",
    verifiedHoursTitle: "Verified volunteer hours",
    noHoursYet: "No records yet",
    viewHours: "View details",
    adjustmentsLabel: "Adjustments",
    eventCol: "Event",
    dateCol: "Date",
    hoursCol: "Hours",
    statusCol: "Status",
    saveSetting: "Save",
    usersHours: "Volunteers' hours",
    deleteAccount: "Delete my account permanently",
    deleteAccountConfirmTitle: "Are you sure you want to delete your account?",
    deleteAccountConfirmHint: "Your account and personal data will be permanently removed. Attendance records are kept anonymously. This action cannot be undone.",
    deleteAccountFinal: "Yes, delete permanently",
    accountDeleted: "Your account has been deleted",
    optionalLabel: "optional",
    nidWhyHint: "Helps link your event attendance and volunteer hours to your account automatically",
    brand: "Events",
    tagline: "Simple, fast event registration",
    heroHeadline: "Welcome to the Events Registration Platform",
    heroSub:
      "Choose the right opportunity for you, complete the form, and use the QR code to check in your attendance.",
    whatsappCta: "For any inquiries, message me on WhatsApp",
    footerText: "Event Registration Platform — Unofficial trial platform — Platform rights: Muhammed S K",
    exploreCta: "Browse events",
    adminCta: "Sign in",
    activeEvents: "Active events",
    noEvents: "No active events right now. Please check back later.",
    register: "Register",
    fullText: "Full",
    expired: "Expired",
    login: "Log in",
    logout: "Log out",
    email: "Email",
    password: "Password",
    signIn: "Sign in",
    adminPanel: "Admin",
    dashboard: "Dashboard",
    forms: "Forms",
    scanner: "Scanner",
    createForm: "New form",
    editForm: "Edit form",
    delete: "Delete",
    confirmDelete: "Delete this form and all its submissions?",
    title: "Title",
    titleAr: "Title (Arabic)",
    description: "Description",
    descriptionAr: "Description (Arabic)",
    visibility: "Visibility",
    publicOpt: "Public — show on landing page",
    linkOnly: "Secret link — only via link",
    isActive: "Active (open for registration)",
    expiresAt: "Expiry (optional)",
    maxSubmissions: "Max submissions (optional)",
    coverImage: "Cover image URL (optional)",
    location: "Location (optional)",
    eventDate: "Event date (optional)",
    fields: "Form fields",
    addField: "Add field",
    fieldLabel: "Label",
    fieldLabelAr: "Label (Arabic)",
    fieldType: "Type",
    fieldRequired: "Required",
    fieldSummary: "Include in short CSV",
    fieldUnique: "Prevent duplicates (unique field)",
    duplicateError: "This value is already registered for this event.",
    fieldOptions: "Options",
    fieldKey: "Field key",
    saveForm: "Save form",
    savingForm: "Saving…",
    submissions: "Submissions",
    exportShort: "Export short CSV",
    exportFull: "Export full CSV",
    exportAttended: "Export attendees only",
    printAttendance: "Print attendance sheet",
    attendanceSheet: "Attendance sheet",
    signature: "Signature",
    supervisorSignature: "Supervisor signature",
    organizerSignature: "Organizer signature",
    printedAt: "Printed on",
    totalAttendees: "Total attendees",
    noAttendeesYet: "No attendees checked in yet.",
    copyLink: "Copy link",
    linkCopied: "Link copied to clipboard",
    submitted: "Submitted at",
    ticketCode: "Ticket code",
    ticketDateLabel: "Event date",
    comingSoon: "Coming soon 🚀",
    addToWallet: "Add to wallet",
    digitalIdTitle: "My Digital ID",
    digitalIdHint: "Show this code to the supervisor for instant check-in — works even offline",
    scanEventSelect: "Check-in event",
    selectEventFirst: "Select the event first to scan ID cards",
    scanPendingCreated: "Attendance request submitted — awaiting approval",
    scanPendingExists: "Already has a pending request — awaiting approval",
    scanRegisteredNow: "Registered to the event via ID card",
    pendingRequestsTab: "Pending requests",
    approveAndCheckin: "Approve & check-in",
    offlineQueued: "Checked in locally (offline) — will sync automatically when online",
    alreadyQueuedOffline: "Already queued for sync",
    syncNow: "Sync now",
    syncDone: "Synced",
    pendingSyncCount: "records pending sync",
    offlineMode: "Offline",
    checkedIn: "Checked in",
    yes: "Yes",
    no: "No",
    scanQr: "Scan a QR code or enter code manually",
    startCamera: "Start camera",
    stopCamera: "Stop camera",
    manualCode: "Manual code entry",
    checkIn: "Check in",
    alreadyCheckedIn: "Already checked in",
    successCheckIn: "Attendance recorded",
    ticketNotFound: "Ticket not found",
    formClosed: "Registration is closed",
    submitRegistration: "Submit registration",
    submitting: "Submitting…",
    yourTicket: "Your ticket",
    ticketHelp: "Save this QR code. Show it at the event entrance for check-in.",
    print: "Print",
    backHome: "Back to events",
    stats: "Overview",
    totalForms: "Total forms",
    activeForms: "Active forms",
    totalSubmissions: "Total submissions",
    checkedInStat: "Checked in",
    invalidCreds: "Invalid email or password",
    all: "All",
    onlyCheckedIn: "Only checked in",
    notCheckedIn: "Not checked in",
    search: "Search…",
    fieldTypeText: "Text",
    fieldTypeEmail: "Email",
    fieldTypeTel: "Phone",
    fieldTypeNumber: "Number",
    fieldTypeTextarea: "Long text",
    fieldTypeSelect: "Dropdown",
    fieldTypeRadio: "Radio (single choice)",
    fieldTypeCheckbox: "Checkbox (multiple)",
    fieldTypeDate: "Date",
    saveChanges: "Save changes",
    cancel: "Cancel",
    close: "Close",
    formLink: "Registration link",
    secretLink: "Secret link",
    remove: "Remove",
    unnamedForm: "Untitled form",
    noSubmissions: "No submissions yet.",
    createFirst: "Create your first registration form to get started.",
    view: "View",
    ticketFor: "Ticket for",
    printedName: "Printed name",
    of: "of",
    fromCamera: "From camera",
    manualEntry: "Manual entry",
    languageToggle: "العربية",
    theme: "Platform Events",
    invitesSection: "Invitations",
    inviteByEmail: "Invite by email",
    inviteSent: "Invitation sent",
    invitePendingS: "Pending",
    inviteUsedS: "Accepted",
    inviteExpiredS: "Expired",
    copyInviteLink: "Copy link",
    revokeInvite: "Revoke",
    inviteWelcome: "Welcome to the team!",
    inviteRoleIntro: "You have been invited to join as",
    acceptInvite: "Accept invitation & create account",
    inviteAcceptedToast: "Account created successfully",
    inviteNote: "An invitation link will be emailed — valid for 7 days.",
    broadcastNav: "Broadcast",
    broadcastHeading: "Send notification",
    notifTitleLabel: "Notification title",
    notifBodyLabel: "Notification text",
    notifTargetLabel: "Send to",
    targetAll: "All users",
    targetForm: "Event registrants",
    targetUsers: "Specific users",
    selectEvent: "Select event",
    searchUsers: "Search users…",
    sendNotifBtn: "Send notification",
    notifSentTo: "Notification sent to:",
    rateExperience: "Rate your experience",
    surveyThanks: "Thank you for your feedback!",
    surveyCommentLabel: "Your feedback (optional)",
    submitRating: "Submit rating",
    surveyResults: "Ratings",
    avgRating: "Average rating",
    highlightsComments: "What participants say",
    topParticipants: "TOP",
    topVolunteers: "Top volunteers by hours",
    surveyToggle: "Post-event rating survey",
    surveyToggleHint: "Automatically sent to attendees ~3 hours after the event ends (push + email).",
    alreadyRegisteredBadge: "Already registered",
    alreadyRegisteredHint: "We found a previous registration with this account — no need to register again.",
    viewMyTicket: "View my ticket",
    attendCountLabel: "participations",
    badgeBronze: "Bronze",
    badgeSilver: "Silver",
    badgeGold: "Gold",
    badgeDiamond: "Diamond",
    myAttendance: "My attendances",
    nextBadgeHint: "attendances left to reach",
    searchByNationalId: "Check-in by national ID",
    uploadTicketImage: "Upload ticket image",
    qrNotFoundInImage: "No QR code found in the image",
    noMatches: "No matches found",
    commentsTitle: "Comments",
    featureComment: "Feature on homepage",
    unfeatureComment: "Unfeature",
    featuredBadge: "Featured",
    manageLeaderboard: "Leaderboard",
    leaderboardHint: "Top attendees (auto-calculated). Control visibility and the displayed name for each user.",
    hiddenFromBoard: "Hidden",
    visibleOnBoard: "Visible",
    displayNameLabel: "Display name",
    resetName: "Reset to real name",
    closeThread: "Close chat",
    reopenThread: "Reopen",
    deleteThread: "Delete chat",
    clearAllThreads: "Clear all chats",
    activeThreads: "Active",
    closedThreads: "Closed",
    closedBadge: "Closed",
    confirmAction: "Are you sure? This cannot be undone.",
    // Location
    locationName: "Location name",
    locationUrl: "Map link (Google Maps / Apple Maps)",
    openMap: "Open in maps",
    // Options builder
    typeOptionAndPress: "Type an option and press Enter",
    addOption: "Add",
    noOptionsYet: "No options yet",
    // Supervisors / users
    supervisors: "Supervisors",
    manageSupervisors: "Manage supervisors",
    addSupervisor: "Add supervisor",
    name: "Name",
    role: "Role",
    roleAdmin: "Admin",
    roleSupervisor: "Events supervisor",
    supervisorNote: "Supervisors can only scan QR codes and register attendance.",
    createUser: "Create account",
    createdAt: "Created",
    deleteUser: "Remove",
    confirmDeleteUser: "Remove this user?",
    userCreated: "User created",
    supervisorMode: "Check-in supervisor",
    errFullName: "Please enter your full name (at least three parts)",
    errNationalId: "National ID must be exactly 10 digits",
    errPhone: "Phone number must start with 05 and be 10 digits",
    statsPage: "Statistics",
    liveStats: "Live statistics",
    todaySubmissions: "Today's registrations",
    todayCheckins: "Today's check-ins",
    quarterlyStats: "Quarterly statistics",
    yearlyStats: "Yearly statistics",
    registrations: "Registrations",
    attendance: "Attendance",
    autoRefresh: "Updates automatically every 10 seconds",
    noStatsData: "No data yet.",
    changePassword: "Change password",
    currentPassword: "Current password",
    newPassword: "New password",
    confirmNewPassword: "Confirm new password",
    passwordChanged: "Password changed successfully",
    passwordMismatch: "Passwords do not match",
    passwordTooShort: "Password must be at least 8 characters",
    liveDisplay: "Live display",
    liveAttendance: "Live attendance",
    attendedCount: "Attended",
    registeredCount: "Registered",
    quickActions: "Quick actions",
    save: "Save",
    phoneHint: "05XXXXXXXX",
    notes: "Notes",
    perEventStats: "Event details",
    eventCol: "Event",
    attendanceRate: "Attendance rate",
    capacity: "Capacity",
    openDashboard: "Dashboard",
    myTickets: "My tickets",
    myTicketsHint: "Tickets saved on this device — available even without internet.",
    noSavedTickets: "No saved tickets yet. Register for an event and your ticket will be saved here automatically.",
    ticketHistory: "History",
    noActiveTickets: "No active tickets right now.",
    shareTicket: "Share",
    linkCopied: "Link copied",
    backHome: "Back to home",
    requiresApproval: "Conditional acceptance (supervisor approval required)",
    requiresApprovalHint: "Registrations stay pending until you approve them; the ticket activates after approval.",
    pendingApproval: "Pending approval",
    approvedStatus: "Approved",
    approve: "Approve",
    reject: "Reject",
    approvedToast: "Registration approved and ticket sent",
    rejectedToast: "Registration rejected and removed",
    pendingTicketNote: "Your request has been received and is pending supervisor approval. Your ticket will be activated and emailed to you once approved.",
    extraOptions: "Extra options",
    statusCol: "Status",
    createAccount: "Create account",
    forgotPassword: "Forgot password?",
    resetPassword: "Reset password",
    newPassword: "New password",
    sendResetLink: "Send reset link",
    resetEmailSent: "If the email exists, a reset link has been sent. Check your inbox (valid for 1 hour).",
    passwordChanged: "Password changed. You can sign in now.",
    addToCalendar: "Add to calendar",
    roleUser: "User",
    onlineNow: "Online now",
    lastSeen: "Last seen",
    neverSeen: "Never signed in",
    agoMin: "min ago",
    agoHour: "h ago",
    agoDay: "d ago",
    editUser: "Edit",
    saveChanges: "Save changes",
    optionalNewPassword: "New password (optional)",
    staffSection: "Admins & supervisors",
    membersSection: "Registered users",
    exportStats: "Export stats (CSV)",
    topCreators: "Top event creators",
    topCheckers: "Top check-in supervisors",
    createdByLabel: "Created by",
    updatedByLabel: "Last edited by",
    eventsCountCol: "Events",
    userUpdated: "Changes saved",
    loginTitle: "Sign in to the platform",
    roleSuper: "Platform Manager",
    auditLog: "Activity log",
    auditLogHint: "Sensitive operations: who did what and when",
    noAuditEntries: "No activity yet",
    byActor: "By",
    uploadImage: "Upload image",
    imageUploaded: "Image uploaded",
    regTimeLeft: "Registration closes in",
    daysUnit: "day(s)",
    hoursUnit: "hour(s)",
    minsUnit: "min",
    hasCertificate: "Attendance certificate",
    hasCertificateHint: "After check-in, attendees can download an attendance certificate",
    certificate: "Attendance certificate",
    printCertificate: "Print / Save PDF",
    eventTime: "Event time (check-in opens 1h before)",
    certVerified: "Verified certificate ✓",
    certVerifiedHint: "This certificate was issued by the Events Registration Platform",
    certInvalid: "Invalid or unavailable certificate",
    attendeeName: "Attendee",
    eventName: "Event",
    haveAccount: "Have an account? Sign in",
    noAccount: "No account? Create one",
    myAccount: "My account",
    fullNameLabel: "Full name",
    nationalIdLabel: "National ID",
    phoneLabel: "Phone",
    accountCreated: "Account created successfully",
    oneClickNote: "You are signed in — your details were filled automatically",
    supportChat: "Support",
    supportPlaceholder: "Write a message to the supervisor...",
    send: "Send",
    noMessages: "No messages yet — write your question and the supervisor will reply.",
    privacyPolicy: "Privacy Policy",
    termsOfUse: "Terms of Use",
    upcomingEvents: "Upcoming events",
    supportInbox: "Support inbox",
    noThreads: "No conversations yet.",
    darkMode: "Dark mode",
    userLoginTitle: "Sign in",
    scanToRegister: "Register now",
    scanToRegisterHint: "Scan the code with your phone camera to register",
    seatsLeft: "seats left",
    soldOut: "Fully booked",
  },
  ar: {
    volunteerHours: "ساعات التطوع",
    myHours: "ساعاتي التطوعية",
    totalHours: "إجمالي الساعات",
    hoursUnit: "ساعة",
    eventHours: "الساعات التطوعية للفعالية",
    eventHoursHint: "تُحتسب الساعات للمشارك فقط بعد التحقق من حضوره (المسح)",
    hoursStatement: "كشف الساعات التفصيلي",
    annualCertificate: "الشهادة السنوية",
    attendedLabel: "حضر",
    missedLabel: "لم يحضر",
    manualAdjust: "تعديل يدوي",
    adjustHours: "تعديل الساعات",
    adjustNote: "السبب / ملاحظة",
    adjustAmountHint: "رقم موجب للإضافة، وسالب للخصم",
    enableVolunteerHours: "تفعيل نظام ساعات التطوع",
    volunteerHoursSettingHint: "عند التفعيل يستطيع الأدمن وضع ساعات للفعاليات وتُحتسب للمتطوعين عند تأكيد الحضور",
    hoursAdminTitle: "إدارة ساعات التطوع",
    featureDisabled: "هذه الخاصية غير مفعّلة حالياً من مدير المنصة",
    printStatement: "طباعة الكشف",
    shareCertificate: "مشاركة",
    verifiedHoursTitle: "ساعات تطوعية موثقة ✓",
    noHoursYet: "لا توجد سجلات بعد",
    viewHours: "عرض التفاصيل",
    adjustmentsLabel: "التعديلات",
    eventCol: "الفعالية",
    dateCol: "التاريخ",
    hoursCol: "الساعات",
    statusCol: "الحالة",
    saveSetting: "حفظ",
    usersHours: "ساعات المتطوعين",
    deleteAccount: "حذف حسابي نهائياً",
    deleteAccountConfirmTitle: "هل أنت متأكد من حذف حسابك؟",
    deleteAccountConfirmHint: "سيُحذف حسابك وبياناتك الشخصية نهائياً ولا يمكن التراجع. تُحفظ سجلات الحضور بصورة مجهولة الهوية.",
    deleteAccountFinal: "نعم، احذف نهائياً",
    accountDeleted: "تم حذف حسابك",
    optionalLabel: "اختياري",
    nidWhyHint: "يساعد على ربط حضورك وساعاتك التطوعية بحسابك تلقائياً",
    brand: "فعاليات",
    tagline: "تسجيل فعاليات سلس وسريع",
    heroHeadline: "حياك الله في منصة تسجيل الفعاليات...",
    invitesSection: "الدعوات",
    inviteByEmail: "دعوة عبر البريد",
    inviteSent: "تم إرسال الدعوة",
    invitePendingS: "بانتظار القبول",
    inviteUsedS: "تم القبول",
    inviteExpiredS: "منتهية",
    copyInviteLink: "نسخ الرابط",
    revokeInvite: "إلغاء",
    inviteWelcome: "أهلاً بك في الفريق!",
    inviteRoleIntro: "تمت دعوتك للانضمام بصلاحية",
    acceptInvite: "قبول الدعوة وإنشاء الحساب",
    inviteAcceptedToast: "تم إنشاء الحساب بنجاح",
    inviteNote: "سيصل رابط الدعوة عبر البريد الإلكتروني — صالح لمدة 7 أيام.",
    broadcastNav: "الإشعارات",
    broadcastHeading: "إرسال إشعار جماعي",
    notifTitleLabel: "عنوان الإشعار",
    notifBodyLabel: "نص الإشعار",
    notifTargetLabel: "إرسال إلى",
    targetAll: "جميع المستخدمين",
    targetForm: "مسجّلو فعالية",
    targetUsers: "أشخاص محددون",
    selectEvent: "اختر الفعالية",
    searchUsers: "ابحث عن مستخدم…",
    sendNotifBtn: "إرسال الإشعار",
    notifSentTo: "تم إرسال الإشعار إلى:",
    rateExperience: "قيّم تجربتك",
    surveyThanks: "شكراً لتقييمك!",
    surveyCommentLabel: "ملاحظاتك (اختياري)",
    submitRating: "إرسال التقييم",
    surveyResults: "التقييمات",
    avgRating: "متوسط التقييم",
    highlightsComments: "آراء المشاركين",
    topParticipants: "TOP الأفضل",
    topVolunteers: "أفضل المتطوعين بالساعات",
    surveyToggle: "استبيان التقييم بعد الفعالية",
    surveyToggleHint: "يُرسل تلقائياً للحاضرين بعد ٣ ساعات تقريباً من نهاية الفعالية (إشعار + بريد).",
    alreadyRegisteredBadge: "أنت مسجل في هذه الفعالية",
    alreadyRegisteredHint: "وجدنا تسجيلاً سابقاً بهذا الحساب — لا حاجة للتسجيل مرة أخرى.",
    viewMyTicket: "عرض تذكرتي",
    attendCountLabel: "مشاركة",
    badgeBronze: "برونزي",
    badgeSilver: "فضي",
    badgeGold: "ذهبي",
    badgeDiamond: "ماسي",
    myAttendance: "مشاركاتي",
    nextBadgeHint: "مشاركة متبقية للوصول إلى",
    searchByNationalId: "التحضير برقم الهوية",
    uploadTicketImage: "رفع صورة التذكرة",
    qrNotFoundInImage: "لم يتم العثور على كود في الصورة",
    noMatches: "لا توجد نتائج مطابقة",
    commentsTitle: "التعليقات",
    featureComment: "تمييز في الصفحة الرئيسية",
    unfeatureComment: "إلغاء التمييز",
    featuredBadge: "مميّز",
    manageLeaderboard: "لوحة الأبطال",
    leaderboardHint: "أكثر المستخدمين حضوراً (تلقائي) — تحكم في ظهور كل اسم أو عدّله كما يظهر في الصفحة الرئيسية.",
    hiddenFromBoard: "مخفي",
    visibleOnBoard: "ظاهر",
    displayNameLabel: "الاسم المعروض",
    resetName: "إرجاع الاسم الحقيقي",
    closeThread: "إغلاق المحادثة",
    reopenThread: "إعادة فتح",
    deleteThread: "حذف المحادثة",
    clearAllThreads: "مسح كل المحادثات",
    activeThreads: "النشطة",
    closedThreads: "المغلقة",
    closedBadge: "مغلقة",
    confirmAction: "هل أنت متأكد؟ لا يمكن التراجع عن هذا الإجراء.",
    heroSub:
      "اختار الفرصة المناسبة لك وكمل النموذج واستخدم الباركود لتسجيل حضورك",
    whatsappCta: "اي استفسار راسلني على واتس اب",
    footerText: "منصة تسجيل الفعاليات - منصة تجريبية غير رسمية - حقوق المنصة Muhammed S K",
    exploreCta: "استعراض الفعاليات",
    adminCta: "تسجيل الدخول",
    activeEvents: "الفعاليات النشطة",
    noEvents: "لا توجد فعاليات نشطة حالياً. تابعنا لاحقاً.",
    register: "سجّل الآن",
    fullText: "مكتمل",
    expired: "منتهي",
    login: "تسجيل الدخول",
    logout: "تسجيل الخروج",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    signIn: "دخول",
    adminPanel: "الإدارة",
    dashboard: "لوحة التحكم",
    forms: "النماذج",
    scanner: "قارئ الباركود",
    createForm: "نموذج جديد",
    editForm: "تعديل النموذج",
    delete: "حذف",
    confirmDelete: "هل تريد حذف هذا النموذج وكل التسجيلات المرتبطة به؟",
    title: "العنوان",
    titleAr: "العنوان (بالعربية)",
    description: "الوصف",
    descriptionAr: "الوصف (بالعربية)",
    visibility: "الظهور",
    publicOpt: "عام — يظهر في الصفحة الرئيسية",
    linkOnly: "رابط سري — فقط عبر الرابط",
    isActive: "نشط (مفتوح للتسجيل)",
    expiresAt: "تاريخ الانتهاء (اختياري)",
    maxSubmissions: "الحد الأقصى للمسجلين (اختياري)",
    coverImage: "رابط صورة الغلاف (اختياري)",
    location: "الموقع (اختياري)",
    eventDate: "تاريخ الفعالية (اختياري)",
    fields: "حقول النموذج",
    addField: "إضافة حقل",
    fieldLabel: "التسمية",
    fieldLabelAr: "التسمية (بالعربية)",
    fieldType: "النوع",
    fieldRequired: "مطلوب",
    fieldSummary: "ضمّن في CSV المختصر",
    fieldUnique: "منع التكرار (حقل فريد)",
    duplicateError: "هذه القيمة مسجّلة مسبقاً في هذه الفعالية.",
    fieldOptions: "الخيارات",
    fieldKey: "معرّف الحقل",
    saveForm: "حفظ النموذج",
    savingForm: "جارٍ الحفظ…",
    submissions: "التسجيلات",
    exportShort: "تصدير CSV مختصر",
    exportFull: "تصدير CSV كامل",
    exportAttended: "تصدير الحاضرين فقط",
    printAttendance: "طباعة كشف حضور",
    attendanceSheet: "كشف حضور",
    signature: "التوقيع",
    supervisorSignature: "توقيع المشرف",
    organizerSignature: "توقيع المنظّم",
    printedAt: "تاريخ الطباعة",
    totalAttendees: "إجمالي الحاضرين",
    noAttendeesYet: "لم يُسجَّل حضور أي أحد بعد.",
    copyLink: "نسخ الرابط",
    linkCopied: "تم نسخ الرابط",
    submitted: "وقت التسجيل",
    ticketCode: "رمز التذكرة",
    ticketDateLabel: "التاريخ",
    comingSoon: "قريبًا 🚀",
    addToWallet: "أضفها إلى المحفظة",
    digitalIdTitle: "بطاقتي التعريفية",
    digitalIdHint: "اعرض هذا الرمز للمشرف لتسجيل حضورك فورًا — يعمل حتى بدون إنترنت",
    scanEventSelect: "فعالية التحضير",
    selectEventFirst: "اختر الفعالية أولًا لمسح البطاقات التعريفية",
    scanPendingCreated: "تم رفع طلب التحضير بانتظار الاعتماد",
    scanPendingExists: "لديه طلب معلق بالفعل — بانتظار الاعتماد",
    scanRegisteredNow: "تم تسجيله في الفعالية عبر البطاقة",
    pendingRequestsTab: "طلبات الحضور المعلقة",
    approveAndCheckin: "قبول وتحضير",
    offlineQueued: "تم التحضير محلياً (بدون إنترنت) وسيتطابق تلقائياً عند الاتصال",
    alreadyQueuedOffline: "هذا الرمز محفوظ بالفعل في قائمة المزامنة",
    syncNow: "مزامنة الآن",
    syncDone: "تمت المزامنة",
    pendingSyncCount: "سجلات بانتظار المزامنة",
    offlineMode: "بدون اتصال",
    checkedIn: "الحضور",
    yes: "نعم",
    no: "لا",
    scanQr: "امسح الباركود أو أدخل الرمز يدوياً",
    startCamera: "تشغيل الكاميرا",
    stopCamera: "إيقاف الكاميرا",
    manualCode: "إدخال يدوي",
    checkIn: "تسجيل الحضور",
    alreadyCheckedIn: "تم تسجيل الحضور مسبقاً",
    successCheckIn: "تم تسجيل الحضور",
    ticketNotFound: "التذكرة غير موجودة",
    formClosed: "التسجيل مغلق",
    submitRegistration: "إرسال التسجيل",
    submitting: "جارٍ الإرسال…",
    yourTicket: "تذكرتك",
    ticketHelp: "احتفظ بهذا الباركود. اعرضه عند مدخل الفعالية لتسجيل حضورك.",
    print: "طباعة",
    backHome: "العودة للفعاليات",
    stats: "نظرة عامة",
    totalForms: "إجمالي النماذج",
    activeForms: "النماذج النشطة",
    totalSubmissions: "إجمالي التسجيلات",
    checkedInStat: "الحضور المسجّل",
    invalidCreds: "بريد إلكتروني أو كلمة مرور غير صحيحة",
    all: "الكل",
    onlyCheckedIn: "الحاضرون فقط",
    notCheckedIn: "لم يحضروا",
    search: "بحث…",
    fieldTypeText: "نص قصير",
    fieldTypeEmail: "بريد إلكتروني",
    fieldTypeTel: "رقم جوال",
    fieldTypeNumber: "رقم",
    fieldTypeTextarea: "نص طويل",
    fieldTypeSelect: "قائمة منسدلة",
    fieldTypeRadio: "اختيار واحد",
    fieldTypeCheckbox: "اختيار متعدد",
    fieldTypeDate: "تاريخ",
    saveChanges: "حفظ التعديلات",
    cancel: "إلغاء",
    close: "إغلاق",
    formLink: "رابط التسجيل",
    secretLink: "الرابط السري",
    remove: "حذف",
    unnamedForm: "نموذج بدون عنوان",
    noSubmissions: "لا توجد تسجيلات بعد.",
    createFirst: "أنشئ أول نموذج تسجيل لتبدأ.",
    view: "عرض",
    ticketFor: "تذكرة لـ",
    printedName: "الاسم",
    of: "من",
    fromCamera: "بالكاميرا",
    manualEntry: "إدخال يدوي",
    languageToggle: "English",
    theme: "منصة تسجيل الفعاليات",
    // Location
    locationName: "اسم الموقع",
    locationUrl: "رابط الخريطة (قوقل ماب / آبل ماب)",
    openMap: "فتح في الخرائط",
    // Options builder
    typeOptionAndPress: "اكتب الخيار ثم اضغط Enter",
    addOption: "إضافة",
    noOptionsYet: "لا توجد خيارات بعد",
    // Supervisors / users
    supervisors: "المشرفون",
    manageSupervisors: "إدارة المشرفين",
    addSupervisor: "إضافة مشرف",
    name: "الاسم",
    role: "الصلاحية",
    roleAdmin: "أدمن",
    roleSupervisor: "مشرف فعاليات",
    supervisorNote: "المشرف يستطيع فقط قراءة الباركود وتسجيل الحضور، ولا يمكنه إنشاء أو تعديل الفعاليات.",
    createUser: "إنشاء الحساب",
    createdAt: "تاريخ الإنشاء",
    deleteUser: "حذف",
    confirmDeleteUser: "حذف هذا المستخدم؟",
    userCreated: "تم إنشاء المستخدم",
    supervisorMode: "مشرف حضور",
    errFullName: "يرجى إدخال الاسم الثلاثي (ثلاثة أسماء على الأقل)",
    errNationalId: "رقم الهوية يجب أن يتكون من 10 أرقام",
    errPhone: "رقم التواصل يجب أن يبدأ بـ 05 ويتكون من 10 أرقام",
    statsPage: "الإحصائيات",
    liveStats: "إحصائيات مباشرة",
    todaySubmissions: "تسجيلات اليوم",
    todayCheckins: "حضور اليوم",
    quarterlyStats: "إحصائيات ربع سنوية",
    yearlyStats: "إحصائيات سنوية",
    registrations: "التسجيلات",
    attendance: "الحضور",
    autoRefresh: "تحديث تلقائي كل 10 ثوانٍ",
    noStatsData: "لا توجد بيانات بعد.",
    changePassword: "تغيير كلمة المرور",
    currentPassword: "كلمة المرور الحالية",
    newPassword: "كلمة المرور الجديدة",
    confirmNewPassword: "تأكيد كلمة المرور الجديدة",
    passwordChanged: "تم تغيير كلمة المرور بنجاح",
    passwordMismatch: "كلمتا المرور غير متطابقتين",
    passwordTooShort: "كلمة المرور يجب أن تكون 8 أحرف على الأقل",
    liveDisplay: "شاشة العرض",
    liveAttendance: "الحضور المباشر",
    attendedCount: "الحاضرون",
    registeredCount: "المسجّلون",
    quickActions: "إجراءات سريعة",
    save: "حفظ",
    phoneHint: "05XXXXXXXX",
    notes: "ملاحظات",
    perEventStats: "تفاصيل الفعاليات",
    eventCol: "الفعالية",
    attendanceRate: "نسبة الحضور",
    capacity: "السعة",
    openDashboard: "لوحة التحكم",
    myTickets: "تذاكري",
    myTicketsHint: "التذاكر المحفوظة على هذا الجهاز — متاحة حتى بدون إنترنت.",
    noSavedTickets: "لا توجد تذاكر محفوظة بعد. سجّل في فعالية وستُحفظ تذكرتك هنا تلقائياً.",
    ticketHistory: "السجل",
    noActiveTickets: "لا توجد تذاكر حالية.",
    shareTicket: "مشاركة",
    linkCopied: "تم نسخ الرابط",
    backHome: "العودة للرئيسية",
    requiresApproval: "قبول مشروط (بموافقة المشرف)",
    requiresApprovalHint: "تبقى التسجيلات معلّقة حتى توافق عليها، وتتفعّل التذكرة بعد الموافقة.",
    pendingApproval: "بانتظار الموافقة",
    approvedStatus: "مقبول",
    approve: "قبول",
    reject: "رفض",
    approvedToast: "تم قبول التسجيل وإرسال التذكرة",
    rejectedToast: "تم رفض التسجيل وحذفه",
    pendingTicketNote: "تم استلام طلبك وهو الآن بانتظار موافقة المشرف. ستتفعّل تذكرتك وتصلك عبر البريد فور الموافقة.",
    extraOptions: "خيارات إضافية",
    statusCol: "الحالة",
    createAccount: "إنشاء حساب جديد",
    forgotPassword: "نسيت كلمة المرور؟",
    resetPassword: "إعادة تعيين كلمة المرور",
    newPassword: "كلمة المرور الجديدة",
    sendResetLink: "إرسال رابط الاسترجاع",
    resetEmailSent: "إذا كان البريد مسجلاً لدينا فقد أُرسل رابط الاسترجاع. تحقق من بريدك (صالح لمدة ساعة).",
    passwordChanged: "تم تغيير كلمة المرور. يمكنك تسجيل الدخول الآن.",
    addToCalendar: "أضف للتقويم",
    roleUser: "مستخدم",
    onlineNow: "متصل الآن",
    lastSeen: "آخر ظهور",
    neverSeen: "لم يسجل الدخول بعد",
    agoMin: "دقيقة",
    agoHour: "ساعة",
    agoDay: "يوم",
    editUser: "تعديل",
    saveChanges: "حفظ التعديلات",
    optionalNewPassword: "كلمة مرور جديدة (اختياري)",
    staffSection: "المدراء والمشرفون",
    membersSection: "المستخدمون المسجلون",
    exportStats: "تصدير الإحصائيات (CSV)",
    topCreators: "أكثر المشرفين إنشاءً للفعاليات",
    topCheckers: "أكثر المشرفين تسجيلاً للحضور",
    createdByLabel: "أنشأها",
    updatedByLabel: "آخر تعديل",
    eventsCountCol: "عدد الفعاليات",
    userUpdated: "تم حفظ التعديلات",
    loginTitle: "تسجيل الدخول إلى المنصة",
    roleSuper: "مدير المنصة",
    auditLog: "سجل النشاط",
    auditLogHint: "العمليات الحساسة: من فعل ماذا ومتى",
    noAuditEntries: "لا يوجد نشاط مسجل بعد",
    byActor: "بواسطة",
    uploadImage: "رفع صورة",
    imageUploaded: "تم رفع الصورة بنجاح",
    regTimeLeft: "متبقي للتسجيل",
    daysUnit: "يوم",
    hoursUnit: "ساعة",
    minsUnit: "دقيقة",
    hasCertificate: "شهادة حضور للفعالية",
    hasCertificateHint: "بعد تأكيد الحضور يستطيع المشارك تحميل شهادة حضور باسمه",
    certificate: "شهادة الحضور",
    printCertificate: "طباعة / حفظ PDF",
    eventTime: "وقت الفعالية (يُفتح التحضير قبله بساعة)",
    certVerified: "شهادة موثقة ✓",
    certVerifiedHint: "هذه الشهادة صادرة رسمياً من منصة تسجيل الفعاليات",
    certInvalid: "شهادة غير صالحة أو غير متوفرة",
    attendeeName: "اسم الحاضر",
    eventName: "الفعالية",
    haveAccount: "لديك حساب؟ سجّل الدخول",
    noAccount: "ليس لديك حساب؟ أنشئ حساباً",
    myAccount: "حسابي",
    fullNameLabel: "الاسم الثلاثي",
    nationalIdLabel: "رقم الهوية",
    phoneLabel: "رقم التواصل",
    accountCreated: "تم إنشاء حسابك بنجاح",
    oneClickNote: "أنت مسجّل الدخول — تم تعبئة بياناتك تلقائياً",
    supportChat: "الدعم الفني",
    supportPlaceholder: "اكتب رسالتك للمشرف...",
    send: "إرسال",
    noMessages: "لا توجد رسائل بعد — اكتب استفسارك وسيرد عليك المشرف.",
    privacyPolicy: "سياسة الخصوصية",
    termsOfUse: "اتفاقية الاستخدام",
    upcomingEvents: "الأحداث القادمة",
    supportInbox: "رسائل الدعم",
    noThreads: "لا توجد محادثات بعد.",
    darkMode: "الوضع الليلي",
    userLoginTitle: "تسجيل الدخول",
    scanToRegister: "سجّل الآن",
    scanToRegisterHint: "امسح الرمز بكاميرا جوالك للتسجيل في الفعالية",
    seatsLeft: "مقاعد متبقية",
    soldOut: "اكتمل العدد",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem("lang") || "ar";
    } catch {
      return "ar";
    }
  });

  useEffect(() => {
    const dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", lang);
    try {
      localStorage.setItem("lang", lang);
    } catch {}
  }, [lang]);

  const toggleLang = useCallback(() => {
    setLang((l) => (l === "ar" ? "en" : "ar"));
  }, []);

  const t = useCallback(
    (key) => {
      return translations[lang][key] ?? translations.en[key] ?? key;
    },
    [lang]
  );

  return (
    <I18nContext.Provider value={{ lang, t, toggleLang, dir: lang === "ar" ? "rtl" : "ltr" }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used inside I18nProvider");
  return ctx;
}

